import React, { useState, useContext } from 'react';

import { FirebaseContext } from '../../context/firebase';
import { Link } from 'react-router-dom';

export default function PasswordReset() {
	const { firebase } = useContext(FirebaseContext);
	const [formData, setFormData] = useState({
		email: '',
	});

	const { email, password } = formData;

	const [error, setError] = useState('');

	const onChange = (e) =>
		setFormData({ ...formData, [e.target.name]: e.target.value });

	const handleSignin = (e) => {
		e.preventDefault();

		//firebase
		if (email === '') {
			setError('Please enter an email.');
		} else {
			firebase
				.auth()
				.sendPasswordResetEmail(email)
				.then(() => {
					var forgotPasswordElement = document.getElementById('send-again');
					forgotPasswordElement.innerHTML =
						'Email Sent. Send Another? Forgot Password';
				})
				.catch((error) => {
					setFormData('');
					setError(error.message);
					if (error.code == 'auth/invalid-email') {
						setError("Don't see that email, try again? Forgot Password");
					}
				});
		}
	};

	return (
		<>
			<div className='password-reset-form'>
				{error && <p className='form-error'>{error}</p>}
				<form
					className='form formForgetPassword'
					onSubmit={handleSignin}
					method='POST'
				>
					<small>
						We will send you an email to reset your password. Please enter your
						email adress.{' '}
					</small>
					<div className='form-group'>
						<input
							type='email'
							placeholder='Email Address'
							name='email'
							value={email}
							onChange={(e) => onChange(e)}
							required
						/>
					</div>

					<input
						type='submit'
						className='forgotbtn btn btn-primary'
						value='Reset Password'
					/>
					<button className='signupbtn btn btn-light'>
						<Link to='/signin'>Remembered your password?</Link>
					</button>
					<small id='send-again'></small>
				</form>
			</div>
		</>
	);
}
